import React, { useRef } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useOverflow } from 'hooks/useOverflow';
import { useScrollDrag } from 'hooks/useScrollDrag';

import './filter-cards.scss';

const FilterCards = ({ filters, selected, setFilter, className }) => {
  // How to much scroll when clicking scroll button.
  const SCROLL_AMOUNT = 500;

  const horizontalRef = useRef(null);
  const { refXOverflowing, refXScrollBegin, refXScrollEnd } =
    useOverflow(horizontalRef);
  const events = useScrollDrag(horizontalRef, 'vertical', 10);

  const scrollRight = () => {
    horizontalRef.current.scrollTo({
      left: horizontalRef.current.scrollLeft + SCROLL_AMOUNT,
      behavior: 'smooth',
    });
  };

  const scrollLeft = () => {
    horizontalRef.current.scrollTo({
      left: horizontalRef.current.scrollLeft - SCROLL_AMOUNT,
      behavior: 'smooth',
    });
  };

  return (
    <div className="overflow-container">
      <div
        { ...events }
        className={clsx(
          'filter-cards-container',
          className,
          refXOverflowing && 'overflow',
        )}
        ref={horizontalRef}
      >
        <div className="filter-cards">
          {filters.map((statusItem, index) => {

            return (
              <div
                key={`status_item_${index}`}
                className="table_status__card-container"
              >
                <div
                  className={clsx('table_status__card filter-cards__card', {
                    'selected': selected === index,
                  })}
                  onClick={() => {
                    setFilter(index);
                  }}
                  title={className === 'condensed' ? statusItem.name ? statusItem.name : '' : undefined}
                >
                  <div className="status_card status_card--count">
                    {statusItem.count ? Number.isNaN(statusItem.count) ? '0' : statusItem.count : '0'}
                  </div>
                  <div className="status_card status_card--name">{statusItem.name ?? ''}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {refXOverflowing && !refXScrollBegin && (
        <div
          className="horizontal-gradient-left"
          onClick={scrollLeft}
        />
      )}
      {refXOverflowing && !refXScrollEnd && (
        <div
          className="horizontal-gradient-right"
          onClick={scrollRight}
        />
      )}
    </div>
  );
};

FilterCards.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.object),
  selected: PropTypes.number,
  setFilter: PropTypes.func,
  className: PropTypes.string,
};

export default FilterCards;
